// Module
var code = "<section class=\"team-list page-detail-wrapper\"> <div class=\"page-detail\"> <span></span><span></span><span></span><span></span><span></span> </div> <ul data-team-list class=\"team-list-wrap\"> </ul> </section>";
// Exports
export default code;